import { render, staticRenderFns } from "./TopFooter.vue?vue&type=template&id=65892f23&"
import script from "./TopFooter.vue?vue&type=script&lang=js&"
export * from "./TopFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports